export const DUMMY = (desc = "") => () => console.log(`implement ${desc}`)
export const excelPayload = (incomes = [], expenses = []) => ({
    income: incomes,
    expense: expenses,
})

export const updateState = (obj, key, value) => ({ ...obj, [`${key}`]: value })

export const environment = (key) => process.env[`REACT_APP_${key}`]
